
import React from 'react'
import { Route, Switch } from 'react-router'
import ErrorPage from '../error';
import ProfilePage from '../profile';
import LinksPage from '../links';
import CategoriesPage from '../categories';
import LicencesPage from '../licences';
import MultimediaPage from '../multimedia';
import TeamPage from '../team';
import TrademarksPage from '../trademarks';
import ProductsPage from '../products';
import NewsPage from '../news';
import EventDatesPage from '../eventDates';
import ShowroomsPage from '../showrooms';
import CouponsPage from '../coupons';
import JobsPage from '../jobs';
import PrintPage from '../print';

const AppRoutes: React.FC<{}> = () => {
    return (
        <Switch>
            <Route path='/' exact={true} component={ProfilePage} />
            <Route path='/error' component={ErrorPage} />
            <Route path='/profile' component={ProfilePage} />
            <Route path='/categories' component={CategoriesPage} />
            <Route path='/licences' component={LicencesPage} />
            <Route path='/links' component={LinksPage} />
            <Route path='/products' component={ProductsPage} />
            <Route path='/trademarks' component={TrademarksPage} />
            <Route path='/team' component={TeamPage} />
            <Route path='/multimedia' component={MultimediaPage} />
            <Route path='/news' component={NewsPage} />
            <Route path='/eventDates' component={EventDatesPage} />
            <Route path='/showrooms' component={ShowroomsPage} />
            <Route path='/coupons' component={CouponsPage} />
            <Route path='/jobs' component={JobsPage} />
            <Route path='/print' component={PrintPage} />
        </Switch>
    )
}

export default AppRoutes